const InvalidCount = (props) => {
  const { clubPackage, itemCount } = props;
  if (clubPackage.itemChoice !== 'User Can Choose') {
    return null;
  }
  if (!clubPackage.minQuantityInShipment) {
    return null;
  }
  if (itemCount < clubPackage.minQuantityInShipment) {
    const itemsNeed = clubPackage.minQuantityInShipment - itemCount;
    return (
      <div className="c7-message--error">
        You must add {itemsNeed} more item{itemsNeed > 1 && 's'}.
      </div>
    );
  }
  return null;
};

export default InvalidCount;
